import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'lg-not-found',
  templateUrl: './not-found.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  imports: [RouterLink],
})
export class NotFoundComponent {}
